module.exports = __webpack_public_path__ + "img/start.7e50753d.png";